import {
  changeStatus,
  getStatus,
  listOnlyUsers,
  protectAll,
  unprotectAll,
  refresh,
  backupAll,
  backupAllActiveSeats,
  exportSnapshot
} from "@/services/api/app/seat-management/user";
import {defaultPagination,} from "@/services/pagination";

const defaultState = () => ({
  users: [],
  pagination: {
    ...defaultPagination(),
    sortBy: 'name',
    sortDescending: false
  },
  search: null,
  filter: {
    statuses: null,
  },
  status: null
});

export default {
  namespaced: true,

  actions: {
    list({commit, state},) {
      return listOnlyUsers({
        pagination: state.pagination,
        filter: state.filter,
        search: state.search
      })
        .then(({result, pagination}) => {
          commit('setUsers', result)
          commit('setPagination', pagination)
        })
    },
    getStatus({commit}) {
      return getStatus()
        .then(result => {
          commit('setStatus', result)
        })
    },
    refresh({commit}) {
      return refresh()
    },
    changeStatus({commit}, data) {
      return changeStatus(data)
    },
    backupAll() {
      return backupAll()
    },
    backupAllActiveSeats() {
      return backupAllActiveSeats()
    },
    protectAll() {
      return protectAll();
    },
    unprotectAll() {
      return unprotectAll();
    },
    exportSnapshot({commit, state}, {filter, search, pagination}) {
      return exportSnapshot(filter, search, pagination)
    },
  },

  mutations: {
    setUsers(state, users) {
      state.users = users;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    resetPagination(state) {
      state.pagination = {
        ...defaultPagination(),
        sortBy: 'name',
        sortDescending: false
      };
    },
    setSearch(state, search) {
      state.search = search;
    },
    setFilter(state, filter) {
      state.filter = filter;
    },
    setStatus(state, status) {
      state.status = status
    },
    setUserStatus(state, {user, status}) {
      state.users = state.users.map(u => {
        if (u.userId === user.userId) {
          return {
            ...u,
            status: status.value
          }
        }

        return u;
      })
    },
    resetState(state) {
      Object.assign(state, defaultState())
    },
  },


  state: defaultState()
}
